<template>
  <div class="login-box">
    <h2 v-if="title" class="title title--m text-secondary weight-bold">
      {{ title }}
    </h2>
    <ValidationObserver
      class="login-box__form form"
      ref="observer"
      v-slot="{}"
      tag="form"
      @submit.prevent="handleSubmit"
    >
      <fieldset class="form__item">
        <ValidationProvider
          name="número de agendamiento"
          vid="schedule_id"
          rules="required|min:5|max:8"
          v-slot="{ classes, errors }"
          tag="div"
        >
          <div class="login-box__form-inline form-inline">
            <label class="sr-only" for="schedule_id"
              >Número de agendamiento</label
            >
            <input
              type="text"
              :class="['login-box__form-control form-control', classes]"
              id="schedule_id"
              v-model="schedule_id"
              placeholder="Número de agendamiento"
            />
            <span
              class="form-helper form-helper--error d-md-none"
              v-if="errors.length"
              >{{ errors[0] }}</span
            >
            <span class="form-helper d-md-none" v-else>Ej.: FB5SD</span>
            <button
              class="login-box__form-submit button button--secondary"
              type="submit"
              :class="{ 'button--loading': loading }"
              :disabled="loading"
            >
              <span
                class="button__text"
                v-text="loading ? 'Revisando...' : 'Revisar'"
              ></span>
            </button>
          </div>
          <span
            class="form-helper form-helper--error d-none d-md-block"
            v-if="errors.length"
            >{{ errors[0] }}</span
          >
          <span class="form-helper d-none d-md-block" v-else>Ej.: FB5SD</span>
        </ValidationProvider>
      </fieldset>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  name: 'LoginBox',
  props: {
    title: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      schedule_id: '',
    };
  },
  mounted() {
    if (this.code) {
      this.submitForm(this.code);
    }
  },
  methods: {
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      this.submitForm();
    },
    submitForm(code) {
      this.loading = true;

      this.$store
        .dispatch('loginByScheduleId', code || this.schedule_id)
        .then(() => {
          this.$router.push({ name: 'home' });
        })
        .catch(e => {
          console.error(e);
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos logrado consultar tu número de agendamiento',
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
